import { FormInfo } from '../components/tasks/types';

// Valid states we expect
export type EmbeddedFormInfo =
  | {
      embedded_document_url: string;
      form_source: 'pandadoc';
    }
  | {
      form_source: 'form_filler';
      form_magic_link_token: string;
      form_name: string;
      allow_signature_upload: boolean;
    };
// What we expect from the `/task` endpoint
export type RawFormInfo = {
  form?: FormInfo | null;
};

export function validateEmbeddedFormInfo(formInfo: RawFormInfo): EmbeddedFormInfo | null {
  if (!formInfo.form) {
    // There is no form
    return null;
  }
  if (formInfo.form.form_source === 'form_filler') {
    if (!formInfo.form.form_magic_link_token) {
      console.error('Form magic link token not provided for form filler form');
      return null;
    }
    return {
      form_source: 'form_filler',
      form_magic_link_token: formInfo.form.form_magic_link_token,
      form_name: formInfo.form.form_name ?? 'Tandem Form',
      allow_signature_upload: formInfo.form.allow_signature_upload ?? true,
    };
  } else if (formInfo.form.form_source === 'pandadoc') {
    if (!formInfo.form.embedded_document_url) {
      console.error('Embedded document URL not provided for pandadoc form');
      return null;
    }
    return {
      form_source: 'pandadoc',
      embedded_document_url: formInfo.form.embedded_document_url,
    };
  }
  return null;
}
